/* global axios */
import ApiClient from './ApiClient';

class AccountAPI extends ApiClient {
  constructor() {
    super('', { accountScoped: true });
  }

  createAccount(data) {
    return axios.post(`${this.apiVersion}/accounts`, data);
  }

  async getCacheKeys() {
    const response = await axios.get(
      `/api/v1/accounts/${this.accountIdFromRoute}/cache_keys`
    );
    return response.data.cache_keys;
  }

  updateBrandLogo(brandLogo) {
    const formData = new FormData();
    formData.append('brand_logo', brandLogo);
    return axios.patch(
      `/api/v1/accounts/${this.accountIdFromRoute}`,
      formData
    );
  }

  deleteBrandLogo() {
    return axios.delete(
      `/api/v1/accounts/${this.accountIdFromRoute}/brand_logo`
    );
  }
}

export default new AccountAPI();
